import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faDollarSign,
  faNewspaper,
  faBug,
} from "@fortawesome/free-solid-svg-icons";
import scrollToTop from "../utilities/scrollToTop";
import { apiPOST} from "../utilities/apiHelpers";
import { toast } from "react-toastify";

const iconMap = {
  phone: faPhone,
  "dollar-sign": faDollarSign,
  newspaper: faNewspaper,
  bug: faBug,
};

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    isEmail: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    scrollToTop();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg("");
    setErrorMsg("");

    try {
      const res = await apiPOST(
        "/v1/contact-us/add-contact-us",
        formData
      );

      if (res.data.status) {
        setSuccessMsg("Message sent successfully!");
        toast.success("Message sent successfully!");
        setFormData({ name: "", isEmail: "", message: "" });
      }
    } catch (error) {
      setErrorMsg(
        error?.response?.data?.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-8">
      <h2 className="text-center text-3xl font-bold mb-8">Contact us</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Contact Form */}
        <div className="p-6 rounded-lg shadow-sm">
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Name
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="mt-1 block w-full border rounded-md p-2 focus:ring-teal-500"
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                type="email"
                name="isEmail"
                value={formData.isEmail}
                onChange={handleChange}
                required
                className="mt-1 block w-full border rounded-md p-2 focus:ring-teal-500"
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Message
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                className="mt-1 block w-full border rounded-md p-2 focus:ring-teal-500"
              />
            </div>

            {successMsg && (
              <p className="text-green-600 mb-3">{successMsg}</p>
            )}
            {errorMsg && (
              <p className="text-red-600 mb-3">{errorMsg}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-teal-500 text-white py-2 rounded-md hover:bg-teal-600"
            >
              {loading ? "Sending..." : "SEND"}
            </button>
          </form>
        </div>

        {/* Contact Details */}
        <div className="space-y-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <ContactDetail
              icon="phone"
              title="Technical support"
              email="Mediiappindia@gmail.com"
              phone="+91 8588055556"
            />
            <ContactDetail
              icon="dollar-sign"
              title="Sales Enquiries"
              email="Mediiappindia@gmail.com"
              phone="+91 9873320785"
            />
          </div>

          {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <ContactDetail
              icon="newspaper"
              title="Press"
              email="press@example.com"
              phone="+1 234-567-89"
            />
            <ContactDetail
              icon="bug"
              title="Bug report"
              email="bugs@example.com"
              phone="+1 234-567-89"
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

const ContactDetail = ({ icon, title, email, phone }) => (
  <div className="flex items-start space-x-4 p-4 rounded-lg shadow-sm mt-9">
    <div className="text-teal-500 text-2xl">
      <FontAwesomeIcon icon={iconMap[icon]} />
    </div>
    <div>
      <h4 className="text-lg font-semibold">{title}</h4>
      <p className="text-gray-600">{email}</p>
      <p className="text-gray-600">{phone}</p>
    </div>
  </div>
);

export default ContactUs;
